export default "__VITE_ASSET__CLD40cV8__"